<template>
  <BaseCard
    :result="{
      orgName: searchResult.secondary_organization.name,
      orgLink: searchResult.link,
      tagName: $t(`search.links.tagName`),
      id: searchResult.id,
      type: searchResult.type,
      result_position: resultPosition,
      display_text: searchResult.name,
    }"
    class="link-card result-card"
    @result-clicked="handleResultClick"
  >
    <template #preview>
      <div class="preview-fallback">
        <Icon
          name="lucide:link"
          size="24"
        />
      </div>
    </template>
    <template #result-content>
      <a
        :href="url"
        :target="searchResult.content.opens_in_new_tab ? '_blank' : '_self'"
        class="title"
        @click.stop="handleResultClick"
        >{{ searchResult.name }}</a
      >
      <div class="link">{{ formattedURL }}</div>
      <PublishedUpdatedDate :search-result="searchResult" />
    </template>
  </BaseCard>
</template>

<script setup>
import BaseCard from './BaseCard.vue';
import PublishedUpdatedDate from './PublishedUpdatedDate.vue';
import { computed } from 'vue';

const props = defineProps({
  searchResult: {
    type: Object,
    default: () => ({}),
  },
  resultPosition: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['result-clicked']);

const formattedURL = computed(() => {
  const rawUrl = props.searchResult.content.url || '';
  return rawUrl.replace(/^(https?:\/\/)?(www\.)?/, '');
});

const url = computed(() => {
  return props.searchResult.content.url;
});

async function handleResultClick() {
  await navigateTo(url.value, { external: true });
  emit('result-clicked', {
    position: props.resultPosition,
    url: url.value,
  });
}
</script>

<style scoped>
.link-card {
  --color-blue-500: #1850c1;
  --color-blue-50: #f3f6fc;
  --background-color: var(--color-blue-50);
  --text-color: var(--color-blue-500);
}
.link-card .title {
  text-decoration: none;
  line-height: 120%;
}
.link {
  color: var(--color-text-secondary);
  font-size: 12px;
}
</style>
